export const getQueryMap = (
  proxyHost: string,
  id: number,
  country: string | undefined,
  language: string,
  locale: string,
) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const queryMap = new Map([
    [
      "sections.calendar-section",
      `${proxyHost}/new-content/corners/calendar/${id}/${language}`,
    ],
    [
      "sections.deals",
      `${proxyHost}/new-content/corners/games/${id}/${country}/${language}`,
    ],
    [
      "sections.top-games-section",
      `${proxyHost}/new-content/corners/top-games/${id}/${country}/${language}`,
    ],
    [
      "sections.deal-aggregator",
      [
        `${proxyHost}/new-content/corners/deals/${id}/${country}/${language}`,
        `${proxyHost}/eneba?region=${country}&size=18`,
      ],
    ],
    [
      "sections.free-games",
      `${proxyHost}/new-content/corners/free-games/${id}/${country}/${language}`,
    ],
    [
      "sections.trailer-section",
      `${proxyHost}/new-content/corners/trailers/${id}/${language}`,
    ],
    [
      "sections.banner-section",
      `${proxyHost}/new-content/corners/banner/${id}/${language}`,
    ],
    [
      "sections.html-games-section",
      `${proxyHost}/new-content/corners/html-games/${id}/${language}`,
    ],
    [
      "sections.news-section",
      `https://speeddials.opera.com/api/v3/news?_limit=200&category=ga&country=${country}&language=${language}&locale=${locale}`,
    ],
    [
      "sections.banner-section",
      `${proxyHost}/new-content/corners/banner/${id}/${language}`,
    ],
    [
      "sections.daily-section",
      `${proxyHost}/new-content/daily-sections/mobile/${id}/${country}/${language}?pagination[limit]=200`,
    ],
    [
      "sections.video-section",
      `${proxyHost}/new-content/corners/video/${id}/${language}`,
    ],
  ]);

  return queryMap;
};

export const getSupportedSectionTypes = () => {
  const queryMap = getQueryMap("", 0, "", "", "");
  return Array.from(queryMap.keys());
};
